import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import HeroSection from "./HeroSection";
import MenuSection from "./MenuSection";
import Footer from "../../components/ui/Footer";
import FloatingWhatsAppButton from "../../components/ui/FloatingWhatsAppButton";
import CartSidebar from "../../components/ui/cartSideBar";
import { Toaster } from "../../components/ui/toaster";
import { useCart } from "../../hooks/useCart.jsx";

/**
 * Home - Página inicial da aplicação Conecta-Loja
 *
 * Página principal que apresenta a landing page da aplicação,
 * contendo todas as seções principais para atrair e engajar os usuários.
 * Inclui metadados SEO para otimização de motores de busca.
 * Integra o sidebar do carrinho para permitir visualização e gerenciamento dos itens.
 *
 * @returns {JSX.Element} Página inicial completa com todas as seções
 *
 * @example
 * // Renderizada automaticamente pelo sistema de roteamento
 * <Route path="/" element={<Home />} />
 */

const Home = () => {
  const {
    items: cartItems,
    isCartOpen,
    closeCart,
    updateQuantity,
    removeItem,
    clearCart,
    checkout,
  } = useCart();

  return (
    <>
      <Helmet>
        <title>Conecta Loja</title>
        <meta name="description" content="" />
        <meta property="og:title" content="Conecta Loja " />
        <meta property="og:description" content="" />
      </Helmet>

      <div className="w-full bg-white overflow-x-hidden">
        <Header />
        <main>
          <HeroSection />
          <MenuSection />
        </main>
        <Footer />
        <FloatingWhatsAppButton />
        <Toaster />

        {/* Cart Sidebar */}
        <CartSidebar
          isOpen={isCartOpen}
          onClose={closeCart}
          cartItems={cartItems}
          onUpdateQuantity={updateQuantity}
          onRemoveItem={removeItem}
          onClearCart={clearCart}
          onCheckout={checkout}
        />
      </div>
    </>
  );
};

export default Home;
